var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._v(_vm._s(_vm.option.title)+"\n  "),_c('span',{staticClass:"title-hint-text"},[_vm._v("<"+_vm._s(_vm.__('yyyy-mm-dd'))+">")])])
}
var staticRenderFns = []

export { render, staticRenderFns }